<template>
  <b-row class="text-uppercase">

    <b-col lg="8" class="mb-2">
      <h5 class="text-primary font-weight-bold">
        {{$t($getConst.pages.timesheet.timesheet_start_date)}}:
        <span id="startDate" class="text-secondary">{{startDate | localDate}}</span>
      </h5>
      <p class="text-dark font-weight-bold mb-0">
        {{$t($getConst.pages.timesheet.timesheet_contract_number)}}:
        <span id="contractId" class="font-weight-light">{{contractId}}</span>
      </p>
      <p class="text-dark font-weight-bold mb-0">
        {{$t($getConst.pages.timesheet.timesheet_id_number)}}:
        <span id="timesheetId" class="font-weight-light">{{timesheetId}}</span>
      </p>
      <p class="text-dark font-weight-bold mb-0">
        {{$t($getConst.pages.timesheet.timesheet_organisation)}}:
        <span id="companyName" class="font-weight-light">{{companyName}}</span>
      </p>
      <p class="text-dark font-weight-bold mb-0">
        {{$t($getConst.pages.timesheet.timesheet_role)}}:
        <span id="jobTitle" class="font-weight-light">{{jobTitle}}</span>
      </p>
      <div class="d-flex">
        <p class="text-dark font-weight-bold mb-0">
          {{$t($getConst.pages.timesheet.timesheet_approver_name)}}(s):
        </p>
        <ul class="mb-0" v-if="Array.isArray(approversNames) && approversNames.length > 1">
          <li v-for="approver in approversNames">{{approver}}</li>
        </ul>
        <span v-else-if="Array.isArray(approversNames)" class="font-weight-light">{{approversNames[0]}}</span>
        <span v-else class="font-weight-light">{{approversNames}}</span>
      </div>
      <p class="text-dark font-weight-bold mb-0" v-if="isWorker() && (timesheet.Status === 'Returned' || timesheet.Status === 'Returned by Hays')">
        {{$t($getConst.pages.timesheet.rejection_reason)}}:
        <span id="rejectionReason" class="font-weight-light">{{getRejectionReason()}}</span>
      </p>
    </b-col>

    <b-col lg="4">
      <h5 class="text-primary font-weight-bold">
        {{$t($getConst.pages.timesheet.timesheet_status)}}:
        <span class="text-secondary">{{status}}</span>
      </h5>
    </b-col>

  </b-row>
</template>

<script>
  export default {
    name: "TimesheetDetailsHeader",
    props: {
      timesheet: null,
      startDate: {
        type: String,
        required: true
      },
      contractId: {
        type: String,
        required: true
      },
      timesheetId: {
        type: String,
        required: true
      },
      companyName: {
        type: String,
        required: true
      },
      jobTitle: {
        type: String,
        required: true
      },
      approversNames: {
        type: String|Array,
        required: true
      },
      status: {
        type: String,
        required: true
      }
    },
    methods:{
      getRejectionReason(){
        for(let i=0; i<this.timesheet.Approvers.length; i++){
          if(this.timesheet.Approvers[i].date != null){
            return this.timesheet.Approvers[i].RejectionReason;
          }
        }
      }
    }
  }
</script>

<style scoped>
  span {
    margin-left: .5rem;
  }
</style>
